import { render, staticRenderFns } from "./ReleaseNotesModal.vue?vue&type=template&id=392eae30&scoped=true"
import script from "./ReleaseNotesModal.vue?vue&type=script&lang=js"
export * from "./ReleaseNotesModal.vue?vue&type=script&lang=js"
import style0 from "./ReleaseNotesModal.vue?vue&type=style&index=0&id=392eae30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392eae30",
  null
  
)

export default component.exports